if (!customElements.get('product-form')) {
	customElements.define('product-form', class ProductForm extends HTMLElement {
		constructor() {
			super();

			this.form = this.querySelector('form');
			this.form.querySelector('[name=id]').disabled = false;
			this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
			this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
			this.submitButton = this.querySelector('[type="submit"]');
			if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

			this.hideErrors = this.dataset.hideErrors === 'true';
			// 追加 START -------------------------------------------------------
			// 以下、base_files/js/priduct_submit.js にて定義
			this.error_text_box = new errorTextBox(this.form);

			const variantEnrollmentDate = document.getElementById('variant_enrollment_date');
			if(variantEnrollmentDate !== null) {
				const select = variantEnrollmentDate.querySelector('select');
				if(select) {
					const strChangeDate = (date,maxValue = 10) => {
						let get_date = date.slice(0,maxValue);
						get_date = new Date(get_date);
						get_date = (!isNaN(get_date.getDate()))? get_date.getTime() : null;
						return get_date;
					}      
					const option = select.children;
					const selected = select.querySelector('option[selected]');
					let selectedDate = null;
					if(selected) selectedDate = strChangeDate(selected.value);
					const today = new Date();
					const deadline = today.setDate(today.getDate() - 1 + pickupMinDay); // 0 = 当日
					let futureEnd = null;
					if(pickupMaxDay !== null) {
						const eneDay = new Date();
						futureEnd = eneDay.setDate(eneDay.getDate() - 1 + pickupMinDay + pickupMaxDay); // 0 = 当日
						if(futureEnd <= deadline) futureEnd = null;
					}
					let isSelected = false;
					if(futureEnd === null) {
						if(selectedDate !== null && deadline <= selectedDate) isSelected = true;
					} else {
						if(selectedDate !== null && deadline <= selectedDate && futureEnd >= selectedDate) isSelected = true;
					}

					Array.from(option).forEach(e => {
						const time = strChangeDate(e.value);
						if(time === null) return;
						if(deadline > time) {
							if(e.selected) {
								e.removeAttribute('selected');
							}
							e.disabled = true;
							e.parentNode.removeChild(e);
						} else {
							if(!isSelected) {
								e.setAttribute('selected',true);
								isSelected = true;
								isChangeEvent = true;
							}
							if(futureEnd !== null){
								if(futureEnd < time) {
									e.disabled = true;
									e.parentNode.removeChild(e);
								}
							}
						}
					});
				}
			}

			// 配送日カレンダー生成
			this.check_calendaer = new checkCalendaer();
			this.check_calendaer.create_elements(); // カレンダー生成
			this.check_calendaer.create_specified_time(); // 時間指定生成

			// 年齢確認フォーム生成
			this.check_age_verification = new checkAgeVerification('select_age_verification');
			this.check_age_verification.create_elements(); // 年齢確認フォーム生成
			this.check_age_verification.set_storage() // 年齢確認を管理しているストレージの生成
			this.check_age_verification.remove_set_storage() // 年齢確認を管理しているストレージの削除

			this.maxProcutNum = Number(this.submitButton.getAttribute('data-max_product_value'));

			// 追加 END -------------------------------------------------------
		}

		onSubmitHandler(evt) {
			evt.preventDefault();
			// 追加 START -------------------------------------------------------
			// エラー初期化
			this.error_text_box.remove_error_text_box();
			const get_date = new Date();
			const get_today = new Date(get_date.getFullYear(), get_date.getMonth(), get_date.getDate());

			// 配送日カレンダーチェック
			const is_check_calendaer = this.check_calendaer.check_submit(get_today);

			// 年齢確認チェック
				const is_check_age_verification = this.check_age_verification.check_submit();

			if (!is_check_calendaer[0] || !is_check_age_verification[0]) { // 1つでもfalseの場合、以降の処理を止める
				const error_text_html = is_check_calendaer[1] + is_check_age_verification[1];
				this.error_text_box.create_error_text_box(error_text_html);
				return false;
			}

			const quantityElm = document.querySelector('input[name="quantity"]');
			if(quantityElm !== null && this.maxProcutNum > 0) {
				const quantityElmValue = Number(quantityElm.value);
				if(quantityElmValue > this.maxProcutNum) {
					alert(`こちらの商品は一度のご購入で最大${this.maxProcutNum}品までとなります。`);
					return false;
				}
			}

			const cartInProductVariationId = Number(this.form.querySelector('[name=id]').value);
			const cartInProductId = Number(this.form.querySelector('[name=product-id]').value);
			const maxProcutNum = this.maxProcutNum;
			const isVariation = false; // product_submit_cart.jsでも設定あり
			async function fetchDatas() {
				try {
					if(maxProcutNum < 1) return true;
					const response = await fetch('/cart.js');
					const data = await response.json();
					let result = true;
					if(!isVariation) { // 商品ごとに確認する
						let isCartInProduct = false;
						let productQquantity = 0;
						for (let i = 0; i < data.items.length; i++) {
							const e = data.items[i];
							const productId = Number(e.product_id.toString());
							if(cartInProductId === productId) {
								productQquantity += Number(e.quantity.toString());
								if(!isCartInProduct) isCartInProduct = true;
							}
						}
						if(isCartInProduct && productQquantity >= maxProcutNum) {
							alert(`既にカートに${productQquantity}品入っております。\nこちらの商品は一度のご購入で最大${maxProcutNum}品までとなります。`);
							result = false;
						}
					} else { // バリエーションごとに確認する
						for (let i = 0; i < data.items.length; i++) {
							const e = data.items[i];
							const productId = Number(e.id.toString());
							const productQquantity = Number(e.quantity.toString());
							if(productId === cartInProductVariationId && productQquantity >= maxProcutNum) {
								alert(`既にカートに${productQquantity}品入っております。\nこちらの商品は一度のご購入で最大${maxProcutNum}品までとなります。`);
								result = false;
								break;
							}
						}
					}
					return result;
				} catch(error) {
					console.error('Error:', error);
				}
			}
			// 追加 END -------------------------------------------------------
			(async () => {
				const isFetchDatas = await fetchDatas();
				if(!isFetchDatas) return false;
				if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
				this.handleErrorMessage();
	
				this.submitButton.setAttribute('aria-disabled', true);
				this.submitButton.classList.add('loading');
				this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
	
				const config = fetchConfig('javascript');
				config.headers['X-Requested-With'] = 'XMLHttpRequest';
				delete config.headers['Content-Type'];
	
				const formData = new FormData(this.form);
				if (this.cart) {
				formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
				formData.append('sections_url', window.location.pathname);
				this.cart.setActiveElement(document.activeElement);
				}
				config.body = formData;
	
				fetch(`${routes.cart_add_url}`, config)
				.then((response) => response.json())
				.then((response) => {
	
					if (response.status) {
					publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
					this.handleErrorMessage(response.description);
	
					const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
					if (!soldOutMessage) return;
					this.submitButton.setAttribute('aria-disabled', true);
					this.submitButton.querySelector('span').classList.add('hidden');
					soldOutMessage.classList.remove('hidden');
					this.error = true;
						return;
					} else if (!this.cart) {
					window.location = window.routes.cart_url;
						return;
					}
	
					if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
					this.error = false;
					const quickAddModal = this.closest('quick-add-modal');
					if (quickAddModal) {
					document.body.addEventListener('modalClosed', () => {
						setTimeout(() => { this.cart.renderContents(response) });
					}, { once: true });
					quickAddModal.hide(true);
					} else {
					this.cart.renderContents(response);
					}
				})
				.catch((e) => {
					console.error(e);
				})
				.finally(() => {
					this.submitButton.classList.remove('loading');
					if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
					if (!this.error) this.submitButton.removeAttribute('aria-disabled');
					this.querySelector('.loading-overlay__spinner').classList.add('hidden');
				});
			})();
		}

		handleErrorMessage(errorMessage = false) {
			if (this.hideErrors) return;

			this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
			if (!this.errorMessageWrapper) return;
			this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

			this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

			if (errorMessage) {
			this.errorMessage.textContent = errorMessage;
			}
		}
	});
}
